import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useSurveyResponseStore } from '@/stores/SurveyResponseStore';
import { createEmptySurvey, SurveyData } from '@/services/survey-response/models/surveyModels';
import { useToast } from 'vue-toast-notification';

import { watch } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'SurveyView',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const store = useSurveyResponseStore();
const toast = useToast();

const formRef = ref();
const saving = ref(false);

const genderOptions = [
    { title: 'Masculino', value: 'Masculino' },
    { title: 'Femenino', value: 'Femenino' },
];
const reasonOptions = [
    { title: 'Trabajo', value: 'trabajar' },
    { title: 'Estudio', value: 'estudiar' },
    { title: 'Compras', value: 'compras' },
    { title: 'Recreación', value: 'recreacion' },
    { title: 'Volver a casa', value: 'volver_a_casa' },
    { title: 'Otro', value: 'otro' },
];

const rules = {
    required: (v: any) => !!v || v === 0 || 'Campo requerido',
    nonNegative: (v: number) => (v !== undefined && v >= 0) || 'No puede ser negativo',
    integer: (v: number) => Number.isInteger(v) || 'Debe ser un número entero',
};

const form = ref<SurveyData>(createEmptySurvey());

function normalizeGender(gender: string): string {
    const legacyValues: Record<string, string> = {
        masc: 'Masculino',
        fem: 'Femenino',
    };
    return legacyValues[gender.toLowerCase()] || gender;
}

onMounted(async () => {
    const id = route.params.id as string;
    if (id && id !== 'new') {
        // Editing existing survey — data loaded by store via App.vue watcher
        if (store.survey) {
            form.value = { ...store.survey, gender: normalizeGender(store.survey.gender) };
        }
    }
});

// Watch for store survey changes (e.g., after fetch completes)
watch(() => store.survey, (newSurvey) => {
    if (newSurvey && route.params.id !== 'new') {
        form.value = { ...newSurvey, gender: normalizeGender(newSurvey.gender) };
    }
});

async function submitForm() {
    const { valid } = await formRef.value.validate();
    if (!valid) return;

    saving.value = true;
    try {
        const success = await store.saveSurveyResponse(form.value);
        if (success) {
            toast.success('Encuesta guardada correctamente');
            router.push({ name: 'saved-survey' });
        } else {
            toast.error('Error al guardar la encuesta');
        }
    } catch (error) {
        console.error('Error saving survey:', error);
        toast.error('Error al guardar la encuesta');
    } finally {
        saving.value = false;
    }
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    class: "py-6",
    style: {"max-width":"600px"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "text-h6" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                icon: "mdi-clipboard-text",
                class: "mr-2"
              }),
              _createTextVNode(" Encuesta ")
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_form, {
                ref_key: "formRef",
                ref: formRef,
                onSubmit: _withModifiers(submitForm, ["prevent"])
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select, {
                    modelValue: form.value.gender,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.gender) = $event)),
                    items: genderOptions,
                    label: "Género",
                    rules: [rules.required],
                    variant: "outlined",
                    density: "comfortable",
                    class: "mb-2"
                  }, null, 8, ["modelValue", "rules"]),
                  _createVNode(_component_v_text_field, {
                    modelValue: form.value.origin,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.origin) = $event)),
                    label: "Origen",
                    rules: [rules.required],
                    variant: "outlined",
                    density: "comfortable",
                    class: "mb-2"
                  }, null, 8, ["modelValue", "rules"]),
                  _createVNode(_component_v_text_field, {
                    modelValue: form.value.destination,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.destination) = $event)),
                    label: "Destino",
                    rules: [rules.required],
                    variant: "outlined",
                    density: "comfortable",
                    class: "mb-2"
                  }, null, 8, ["modelValue", "rules"]),
                  _createVNode(_component_v_select, {
                    modelValue: form.value.reason,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.reason) = $event)),
                    items: reasonOptions,
                    label: "Motivo del viaje",
                    rules: [rules.required],
                    variant: "outlined",
                    density: "comfortable",
                    class: "mb-2"
                  }, null, 8, ["modelValue", "rules"]),
                  _createVNode(_component_v_text_field, {
                    modelValue: form.value.occupants,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.occupants) = $event)),
                    modelModifiers: { number: true },
                    label: "Cantidad de ocupantes",
                    type: "number",
                    min: "0",
                    step: "1",
                    rules: [rules.required, rules.nonNegative, rules.integer],
                    variant: "outlined",
                    density: "comfortable",
                    class: "mb-2"
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _: 1
              }, 512)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, { class: "px-4 pb-4" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                color: "primary",
                variant: "elevated",
                loading: saving.value,
                onClick: submitForm,
                "prepend-icon": "mdi-content-save"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Guardar encuesta ")
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})